import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserWishListRepository } from './domain/UserWishListRepository'

import { AxiosErrorHandler } from '../../foundation'

export class UserApiWishList implements UserWishListRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  add = async (id: number): Promise<void> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/wish-list/command/user/add-to-wish-list/execute',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<void>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  delete = async (id: number): Promise<void> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/wish-list/command/user/delete-from-wish-list/execute',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<void>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
